import React from 'react'
import CerrarSesion from './CerrarSesion'

import { useOurApi } from "../../hooks/useOurApi"
import  Spinner  from "../Spinner/Spinner"
import MensajeError from '../Mensajes/MensajeError'

function CabeceraPrincipal(){

    const url = `${process.env.REACT_APP_API_AUTORIZACION_URL}/usuarioAutenticado`;
    const { data, isLoading, hasError } = useOurApi(url, {});

    if (isLoading) return <Spinner />;

    if (hasError){
        const mensaje={data:"Fallo obteniendo datos personales. Póngase en contacto con el soporte (soportec@navarra.es) para resolver el problema."};
        return <MensajeError mensaje={mensaje} />;
    }
    const datosPersonales={nif:data.nif,razonSocial:data.razonSocial,ultimoAcceso:data.ultimoAcceso};    
    //va abajo: <label> {datosPersonales.razonSocial} ({datosPersonales.nif}) - {datosPersonales.ultimoAcceso}</label>    

    const formatDateUTC = (dateString) => {
        let fecha = new Date(dateString);
        const dia = fecha.getUTCDate().toString().padStart(2,'0');
        const mes = (fecha.getUTCMonth() + 1).toString().padStart(2,'0');
        const anyo = fecha.getUTCFullYear().toString();

        const hora = fecha.getUTCHours().toString().padStart(2,'0');
        const minuto = fecha.getUTCMinutes().toString().padStart(2,'0');
        const segundo = fecha.getUTCSeconds().toString().padStart(2,'0');

        if (anyo == 9999)
            return 'Primera vez';
        else
            return `${dia}/${mes}/${anyo} ${hora}:${minuto}:${segundo}`;
      }

    function fechaUltimoAcceso()
    {
        if (!datosPersonales || !datosPersonales.ultimoAcceso || !datosPersonales.ultimoAcceso.fechaAcceso) 
            return '';
        else{
            //var fecha = new Date(datosPersonales.ultimoAcceso.fechaAcceso);
            //return fecha.toLocaleString();
            
            return formatDateUTC(datosPersonales.ultimoAcceso.fechaAcceso);

            //return new Intl.DateTimeFormat('es-ES', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(new Date(datosPersonales.ultimoAcceso.fechaAcceso));
        }
    }

    return (
        <div className="navbar navbar-default yamm navbar-fixed-top ">
            <div className="container">

                <div className="ocultar">
                    <a accessKey="0" href="https://www.navarra.es/es/inicio" className="navbar-brand">Navarra.es</a>
                </div>                

                <div className="recursivo ocultar">
                    <ul className="nav navbar-nav navbar-right">                                          
                        <li className="dropdown cerrar-sesion">
                        <CerrarSesion/>                        
                        </li>                        
                    </ul>                   
                </div>                 
          </div>
          <div className="container">
            <ul className="nav navbar-nav navbar-right">   
              <li className="ico-ultimo-acceso">
                <label> Último acceso: {fechaUltimoAcceso()}</label>
              </li>
            </ul>
          </div>
      </div>
        
    )
}

export default CabeceraPrincipal